import { formatDistanceToNow } from 'date-fns'
import { Avatar } from '@pepper/ui'

import { useGetWorkflowLog } from 'utils/hooks/workflows/useGetWorkflowLog'
import s from './OrderStatusLog.module.css'

type Props = {
  itemId: string
}

export const OrderStatusLog = ({ itemId }: Props) => {
  const { data: workflowActivities } = useGetWorkflowLog({
    itemId,
    isPvtDoc: false,
  })

  return (
    <div className={s.workflowHistory}>
      {workflowActivities?.map((activity, idx) => {
        const actionTime = formatDistanceToNow(new Date(activity.created_at), {
          addSuffix: true,
        })
        if (activity.key === 'workflow_status_id') {
          return (
            <>
              <div className={s.activityItem}>
                <div
                  className={s.statusColor}
                  style={{
                    background: `#${activity.status?.current.color}`,
                    outline: `3px solid #${activity.status?.current.color}25`,
                  }}
                />
                <span className={s.name}>{activity.updated_by.name}</span>
                <span className={s.action}>changed status to</span>
                <span className={s.name}>{activity.status?.current.name}</span>
                <div className={s.bullet} />
                <span className={s.time}>{actionTime}</span>
              </div>
              {idx !== workflowActivities?.length - 1 && (
                <div className={s.line} />
              )}
            </>
          )
        } else {
          return (
            <>
              <div className={s.activityItem}>
                {activity.updated_by.avatar ? (
                  <Avatar src={activity.updated_by.avatar} size="small" />
                ) : (
                  <Avatar size="small" className={s.assigneeAvatar}>
                    {activity.assignee?.current?.name?.[0]}
                  </Avatar>
                )}
                <span className={s.name}>{activity.updated_by.name}</span>
                <span className={s.action}>re-assigned to</span>
                <span className={s.name}>
                  {activity.assignee?.current.name ?? 'No Assignee'}{' '}
                  {activity.assignee?.current.isDeleted &&
                    activity.assignee?.current.name &&
                    '(Deleted)'}
                </span>
                <div className={s.bullet} />
                <span className={s.time}>{actionTime}</span>
              </div>
              {idx !== workflowActivities?.length - 1 && (
                <div className={s.line} />
              )}
            </>
          )
        }
      })}
    </div>
  )
}
